export const SET_ITEMS_CART = "CART/SET_ITEMS_CART"
export const SET_CHECKOUT_KEY = "CART/SET_CHECKOUT_KEY"
export const SET_CALLED_GET_ITEMS_CART = "CART/SET_CALLED_GET_ITEMS_CART"
export const SET_DISABLED_VARIATION = "CART/SET_DISABLED_VARIATION"
export const SET_LIST_CART_WITH_ADDITIONAL_PRODUCTS = "CART/SET_LIST_CART_WITH_ADDITIONAL_PRODUCTS"
